'use client';

import { useIsBreakpoint } from '@bedrock/core/hooks';
import BREAKPOINTS from 'lib/tailwindcss/tailwind-screens';

const TRANSFORMED_BREAKPOINTS = Object.fromEntries(
  Object.entries(BREAKPOINTS).map(([key, value]) => {
    const px = Number.parseInt(value, 10);
    return [key, `${px - 1}px`];
  }),
) as Record<keyof typeof BREAKPOINTS, string>;

export function useIsUpTo(breakpoint: keyof typeof TRANSFORMED_BREAKPOINTS) {
  return useIsBreakpoint([breakpoint], TRANSFORMED_BREAKPOINTS);
}
